/**
 * Persist supplier-assist invite token across /register so POST accept can run after
 * USER_REGISTER_SUCCESS (same tab sessionStorage survives /register vs multistep).
 * Distinct from supplier referral URL fragments (referralFragmentPath.ts).
 */

export const PENDING_SUPPLIER_ASSIST_INVITE_TOKEN_STORAGE_KEY = 'os_pending_supplier_assist_invite_token'

export function stashPendingSupplierAssistInviteToken(token: string | null | undefined): void {
  if (typeof window === 'undefined' || token == null) {
    return
  }
  const trimmed = String(token).trim()
  if (!trimmed) {
    return
  }
  try {
    window.sessionStorage.setItem(PENDING_SUPPLIER_ASSIST_INVITE_TOKEN_STORAGE_KEY, trimmed)
  } catch {
    // sessionStorage may be unavailable (private mode, SSR)
  }
}

/** Atomically read and remove the pending token so only one consumer calls accept. */
export function claimPendingSupplierAssistInviteToken(): string | null {
  if (typeof window === 'undefined') {
    return null
  }
  try {
    const value = window.sessionStorage.getItem(PENDING_SUPPLIER_ASSIST_INVITE_TOKEN_STORAGE_KEY)
    if (value) {
      window.sessionStorage.removeItem(PENDING_SUPPLIER_ASSIST_INVITE_TOKEN_STORAGE_KEY)
    }
    return value
  } catch {
    return null
  }
}
